import React from 'react';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import Person from '@mui/icons-material/Person';
import Send from '@mui/icons-material/Send';
import Group from '@mui/icons-material/Group';
import { Persona, PersonaIcon } from '../../../types/HomeTypes';
import { PERSONAS } from '../../../utils/homeData';
import { useInView } from '../../../hooks/useInView';
import './PersonasSection.scss';

const ICON_MAP: Record<PersonaIcon, React.ReactElement> = {
  user: <Person sx={{ fontSize: 22, color: '#fff', display: 'block' }} />,
  send: <Send sx={{ fontSize: 22, color: '#fff', display: 'block' }} />,
  family: <Group sx={{ fontSize: 22, color: '#fff', display: 'block' }} />,
  car: <DirectionsCarIcon sx={{ fontSize: 22, color: '#fff', display: 'block' }} />,
};

function PersonaCard({ persona }: { persona: Persona }) {
  return (
    <div className="personas-section__card">
      <div className="personas-section__icon-circle">
        {ICON_MAP[persona.icon]}
      </div>
      <div className="personas-section__title">{persona.title}</div>
      <div className="personas-section__quote">{persona.quote}</div>
      <div className="personas-section__desc">{persona.desc}</div>
      {persona.extraLink && (
        <div className="personas-section__extra-link">
          <DirectionsCarIcon sx={{ fontSize: 20, color: '#2F3857', flexShrink: 0, display: 'block' }} />
          <span>{persona.extraLink}</span>
        </div>
      )}
    </div>
  );
}

export function PersonasSection() {
  const { ref, inView } = useInView<HTMLDivElement>({ threshold: 0.1 });

  return (
    <section className="personas-section">
      <div className="personas-section__header">
        <h2 className="section-title">
          Uma assinatura, quatro motivos diferentes pra ter
        </h2>
      </div>
      <p className="personas-section__subtitle">
        A oferta é a mesma: carro limpo por assinatura, valor fixo, rede nacional. O que muda é o que cada um resolve com ela.
      </p>
      <div className="personas-section__grid" ref={ref}>
        {PERSONAS.map((persona, index) => (
          <div
            key={persona.title}
            className={`animate-on-scroll${inView ? ' is-visible' : ''}`}
            style={{ transitionDelay: `${index * 0.13}s` }}
          >
            <PersonaCard persona={persona} />
          </div>
        ))}
      </div>
    </section>
  );
}
